<script>
  export let value;
  export let lang = undefined;

  const i18n = {
    notAvailable: {
      cs: 'Prohlídka není k dispozici.',
      en: 'Tour is not available.',
    },
  };
</script>

{#if value.tour[lang]}
  <div class='tour'>
    <iframe class='tour-content' src='https://kuula.co/share/collection/{value.tour[lang]}?vr=1&sd=1&autorotate=0.20' title={value.name[lang]} frameborder='0' allowfullscreen allow='xr-spatial-tracking; gyroscope; accelerometer;' scrolling='no'></iframe>

    <div class='tour-label'> {value.name[lang]} </div>
  </div>
{:else}
  <div class='tour-not-available'>
    {i18n.notAvailable[lang]}
  </div>
{/if}

<style>
  .tour {
    display: flex;
    flex-direction: column;
    gap: 5px;

    width: 100%;
    height: 600px;
  }

  .tour-content {
    width: 100%;
    height: calc(100% - 20px);

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  .tour-label {
    height: 15px;

    color: var(--grey-7);

    font-size: 12px;
    font-style: italic;
  }

  .tour-not-available {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    min-height: 22.5px;

    text-align: center;
    text-transform: uppercase;

    letter-spacing: 1.2px;
  }

  :global(body.dark) .tour-content {
    background: var(--grey-8);
  }

  :global(body.dark) .tour-label {
    color: var(--grey-5);
  }
</style>
